import React, { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { AutoComplete, Button, Card, Space, Typography } from "antd";
import { isEmpty } from "lodash";
import { findRelatedMedUser, getMedRepLevel } from "modules/utilities/utility";
const { Option } = AutoComplete;
const { Meta } = Card;
const { Text } = Typography;

function FromMedSearch({
  medRepSearchValue,
  setMedRepSearchValue,
  medRepSearchData,
  setMedRepSearchData,
  setTargetUserLevel,
  setSelectedUserID,
  setSelectedFromMed,
  medReps,
  setMedRepName,
  setSummaryData,
  setEngCallData,
  setSelectedEngagement,
  setCustomerData,
  setMessage,
}) {
  const [isResponse, setIsResponse] = useState(false);
  const [isCloseDropdown, setIsCloseDropdown] = useState(false);

  const handleClear = () => {
    setMedRepSearchValue("");
    setMedRepSearchData([]);
    setSelectedEngagement([]);
    setCustomerData([]);
    setMedRepName("");
    setSummaryData([]);
    setEngCallData([]);
    setTargetUserLevel(0);
  };

  const handleSearch = (event) => {
    setMedRepSearchValue(event);
    if (isEmpty(event)) setIsCloseDropdown(false);
  };

  const handleSubmit = async () => {
    setIsResponse(true);
    if (!isEmpty(medReps.userRole)) {
      let findRelatedItem = findRelatedMedUser(medReps, medRepSearchValue);

      if (isEmpty(findRelatedItem)) {
        setMessage("Agent not found");
      }
      setMedRepSearchData(findRelatedItem);

      setIsResponse(false);
      setIsCloseDropdown(true);
    } else {
      setMessage("No data availaible");
      setMedRepSearchData([]);
      setIsResponse(false);
    }
  };

  const handleClick = (searchResult) => {
    setSelectedFromMed(searchResult);
    setTargetUserLevel(searchResult.user.level);
    setSelectedUserID(searchResult.user_id);
    setMedRepName(searchResult.user.first_name);
  };

  return (
    <div>
      <div className="d-flex flex-row">
        <div className="flex-fill">
          <AutoComplete
            defaultActiveFirstOption={false}
            filterOption={false}
            onSearch={handleSearch}
            placeholder="Search Med Rep"
            notFoundContent={null}
            open={isCloseDropdown}
            value={medRepSearchValue}
            onSelect={() => setIsCloseDropdown(false)}
            showSearch
            style={{ width: "100%" }}
            suffixIcon={<SearchOutlined />}
          >
            {!isEmpty(medRepSearchData) &&
              medRepSearchData?.map((searchResult, index) => (
                <Option key={index} value={medRepSearchValue}>
                  <Card onClick={() => handleClick(searchResult)}>
                    <Meta
                      title={`${searchResult?.user?.first_name} (${
                        getMedRepLevel[searchResult?.user?.level]
                      })`}
                      description={
                        <Space direction="vertical">
                          <Text>{searchResult?.user?.email}</Text>
                          <Space>
                            <Text>{searchResult?.user?.phone_number} </Text>
                          </Space>
                        </Space>
                      }
                    />
                  </Card>
                </Option>
              ))}
          </AutoComplete>
        </div>
        <div>
          <Space>
            <Button
              style={{ marginLeft: "9px" }}
              icon={<SearchOutlined />}
              type="primary"
              onClick={handleSubmit}
              disabled={isEmpty(medRepSearchValue)}
              loading={isResponse}
            />
            <Button onClick={handleClear} disabled={isEmpty(medRepSearchValue)}>
              Clear
            </Button>
          </Space>
        </div>
      </div>
    </div>
  );
}

export default FromMedSearch;
